
export function timer(range) {
    let mxOffset = 360;
    let date = new Date(Date.now());
    let hours = date.getHours();
    let offset = date.getTimezoneOffset();
    let newOffset = mxOffset - offset;
    let newHours = newOffset / 60;
    hours = hours - newHours;
    //console.log(newOffset,newHours,hours);

    if(hours < range[0] || hours > range[1]) {
        //console.log('out of work time');
        return false;
    }
    if(range[0] <= hours || range[1] > hours) {
        //console.log('during work time');
        return true;
    }
}